<template>
  <div>
    <el-drawer
      title=""
      :visible.sync="showDrawer"
      :with-header="false"
      :append-to-body="true"
      :modal="false"
      :wrapperClosable="false"
    >
      <div class="addDrawerTitle">{{ drawerTitle }}</div>
      <div v-if="drawerMode == 'connectResourceGroup'">
        <div class="titleName">
          {{ $t(`authorization.organization.connectedGroup`) }}
        </div>
        <Table
          :tableConfig="tableConfig"
          :tableData="tableData"
          @callBackAction="callBackAction"
          :api="api"
          :type="tableType"
          @handleSelectionChange="handleSelectionChange"
        />
      </div>
      <div v-if="drawerMode == 'connectResource'">
        <el-tree
          :data="treeData"
          show-checkbox
          node-key="id"
          :props="defaultProps"
        >
        </el-tree>
      </div>
      <div class="bottomBtns">
        <!-- <el-button
          class="yesBtn"
          @click="confirm()"
          v-if="drawerMode != 'connectResourceGroup'"
          >{{ $t(`common.confirm`) }}</el-button
        > -->
        <el-button class="noBtn" @click="setDrawer(false)">{{
          $t(`common.close`)
        }}</el-button>
      </div>
    </el-drawer>
    <Dialog
      :dialogFormVisible="dialogFormVisible"
      @setDialog="setDialog"
      :dialogType="dialogType"
      :dialogTitle="dialogTitle"
      :eventType="eventType"
      :handelNode="handelNode"
      :addType="addType"
      :tableData="tableData2"
      :tableConfig="tableConfig2"
      @queryResourceGroupNot="queryResourceGroupNot"
      @query="query"
      @confirmDeleteRel="confirmDeleteRel"
    />
  </div>
</template>

<script>
import Table from "@/components/table/index.vue";
import Dialog from "./addGroupDialog.vue";
import {
  positionSelectResGroupList,
  userSelectResGroupList,
  positionDelResGroup,
  userDelResGroup,
} from "@/api/authorization.js";
export default {
  name: "LeftDrawer",
  components: { Table, Dialog },
  props: {
    drawerTitle: {
      type: String,
      default: "",
    },
    showDrawer: {
      type: Boolean,
      default: false,
    },
    drawerMode: {
      type: String,
      default: "add",
    },
    type: {
      type: String,
      default: "",
    },
    addoreditForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    handelNode: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      formInline: {}, //存储查询条件
      tableData2: {},
      tableConfig2: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            {
              type: "query",
              name: `common.query`,
              event: "query",
              auth: "user_relgroup_add",
            },
          ],
        },
        table: {
          selection: true,
          columns: [
            {
              prop: "resGroupCode",
              label: `authorization.organization.resGroupCode`,
              width: "",
            },
            {
              prop: "resGroupNameCn",
              label: `authorization.organization.chName`,
              width: "",
            },
            {
              prop: "resGroupName",
              label: `authorization.organization.engName`,
              width: "",
            },
            { prop: "status", label: `common.status`, width: "" },
          ],
          action: {},
        },
      },
      addType: "",
      eventType: "",
      dialogTitle: "",
      dialogType: "",
      dialogFormVisible: false,
      selectedItems: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      api: {},
      tableType: "",
      tableData: {},
      //   addoreditForm: {},
      true: true,
      false: false,
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            {
              type: "query",
              name: `common.query`,
              event: "query",
              auth: "user_relgroup_add",
            },
            {
              type: "add",
              name: `common.add`,
              event: "addResourceGroup",
              auth: "user_relgroup_add",
            },
            {
              type: "remove",
              name: `common.remove`,
              event: "remove",
              auth: "user_relgroup_del",
            },
          ],
        },
        table: {
          selection: true,
          columns: [
            {
              prop: "resGroupCode",
              label: `authorization.organization.resGroupCode`,
              width: "",
            },
            {
              prop: "resGroupNameCn",
              label: `authorization.organization.chName`,
              width: "",
            },
            {
              prop: "resGroupName",
              label: `authorization.organization.engName`,
              width: "",
            },
            { prop: "status", label: `common.status`, width: "" },
          ],
          action: {},
        },
      },
    };
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    callBackAction(param) {
      console.log("param", param);
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      } else {
        this.selectedItems = param.selectedItems;
      }
    },
    //查询已关联资源分组
    query(param) {
      //分页查询资源分组接口selectResGroupList
      //暂存参数
      if (param) {
        this.formInline = param.formInline;
      } else {
        //新增分组后的刷新
      }
      //查询条件
      let data = {
        currentPage: param ? this.formInline.currentPage : 1,
        pageSize: this.formInline.pageSize,
        condition: {
          vagueParam: this.formInline.inputKey,
          org: this.handelNode.rootOrgCode,
          positionCode: this.handelNode.positionCode, //如果是岗位关联
          userId: this.handelNode.userId, //如果是成员关联
          isRel: true,
        },
      };
      if (this.handelNode.positionCode) {
        //岗位请求地址position/selectResGroupList
        positionSelectResGroupList(data).then((res) => {
          this.tableData = res.data;
        });
      } else {
        //成员请求地址user/selectResGroupList
        userSelectResGroupList(data).then((res) => {
            this.tableData = res.data;
        });
      }
    },
    addResourceGroup() {
      // this.$emit("addResourceGroup");
      this.dialogFormVisible = true;
      this.dialogType = "normalType";
      this.dialogTitle = this.$t(`common.add`);
      this.eventType = "addResourceGroup";
    },
    add() {},
    remove() {
      //删除关联的资源分组
      //二次弹窗提醒
      this.dialogFormVisible = true;
      this.dialogType = "yellowType";
      this.dialogTitle = this.$t(`common.alert`);
      // this.$emit("deleteResourceGroup", items.selectedItems);
    },
    setDrawer(v) {
      this.$emit("changeConnectDrawer", v);
    },
    confirm() {
      this.$emit("confirmConnect", this.selectedItems);
    },
    handleSelectionChange(obj) {
      this.selectedItems = obj.selectedItems;
    },
    confirmDeleteRel() {
      console.log("confirmDeleteRel");
      //是确认删除
      let codes = [];
      this.selectedItems.forEach((item) => {
        codes.push(item.resGroupCode);
      });
      if (this.handelNode.positionCode) {
        let data = {
          positionCode: this.handelNode.positionCode,
          rootOrgCode: this.handelNode.rootOrgCode,
          resGroupCodes: codes,
        };
        positionDelResGroup(data).then((res) => {
          if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            //岗位取消关联
            this.query();
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        //用户取消关联
        let data = {
          userId: this.handelNode.userId,
          rootOrgCode: this.handelNode.rootOrgCode,
          resGroupCodes: codes,
        };
        //调用接口，刷新右侧抽屉的列表
        userDelResGroup(data).then((res) => {
          if(res.code=='AUTH_000000'){
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.query();
          }else{
             this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }
    },
    setDialog(v, form, items) {
      console.log("setDialog", v);
      console.log("setDialog", form);
      console.log("items", items);
      // if (v) {
      //   //是保存或删除
      //   if (form === {}) {
      //     if (items) {
      //       //添加资源组
      //       //刷新抽屉
      //     } else {
      //       // this.confirmAddOrg(form);
      //     }
      //   } else {
      //     //删除组织或项目
      //     // this.confirmDelete();
      //   }
      // }
      this.dialogFormVisible = false;
    },
    //查询未关联资源组
    queryResourceGroupNot(param) {
      //查询条件
      let data = {
        currentPage: param.formInline.currentPage,
        pageSize: param.formInline.pageSize,
        condition: {
          vagueParam: param.formInline.inputKey,
          org: this.handelNode.rootOrgCode,
          positionCode: this.handelNode.positionCode, //如果是岗位关联
          userId: this.handelNode.userId, //如果是成员关联
          isRel: false,
        },
      };
      //岗位请求地址position/selectResGroupList
      ///成员请求地址user/selectResGroupList
      if (this.handelNode.positionCode) {
        //岗位请求地址position/selectResGroupList
        positionSelectResGroupList(data).then((res) => {
            this.tableData2 = res.data;
        });
      } else {
        //成员请求地址user/selectResGroupList
        userSelectResGroupList(data).then((res) => {
          this.tableData2 = res.data;
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bottomBtns {
  text-align: left;
}
.titleName {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #343c6a;
  // letter-spacing: 0;
  font-weight: 400;
}
::v-deep .el-drawer__open .el-drawer.rtl {
  width: 660px !important;
}
.addDrawerTitle {
  margin-bottom: 17px;
}
::v-deep .el-drawer__open .el-form-item {
  height: 52px;
  line-height: 52px;
}
.tableArea {
  margin: 0;
}
</style>
